import { Modal } from '@design/components/modal/Modal';
import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './ConfirmationModal.module.scss';

interface ConfirmationModalProps {
  onConfirm: () => void;
  onClose: () => void;
  onCancel: () => void;
  hasActiveListInAddMode: boolean;
  selectedEntitiesCount: number;
}

export const ConfirmationModal = ({
  onClose,
  onCancel,
  onConfirm,
  hasActiveListInAddMode,
  selectedEntitiesCount,
}: ConfirmationModalProps) => {
  const { t } = useTranslation(['watchlistManager']);
  return (
    <Modal
      className={styles.styledModal}
      data-testid="confirmation-modal"
      isOpen
      title={t('watchlistManager:confirmationModal.title')}
      cancelBtnProps={{
        label: t('watchlistManager:confirmationModal.dontSave'),
        onClick: onCancel,
      }}
      primaryBtnProps={{
        label: hasActiveListInAddMode
          ? t('watchlistManager:confirmationModal.addAssetsToWatchlist', {
              count: selectedEntitiesCount,
            })
          : t('watchlistManager:confirmationModal.save'),
        onClick: onConfirm,
      }}
      onClose={onClose}
    >
      <p className={styles.label}>
        {hasActiveListInAddMode
          ? t('watchlistManager:confirmationModal.addContent')
          : t('watchlistManager:confirmationModal.content')}
      </p>
    </Modal>
  );
};
